"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 13.166l10 2.857V7.326L8 10.183v2.983zm-2 1.131a.5.5 0 00.363.481l13 3.714a.5.5 0 00.637-.48V5.337a.5.5 0 00-.637-.48l-13 3.714a.5.5 0 00-.363.48v5.246z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 15.675v-2h2v2a1 1 0 102 0v-1h2v1a3 3 0 11-6 0z\" fill=\"#000\"></path><path d=\"M3 8.925a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25v5.5a.25.25 0 01-.25.25h-1.5a.25.25 0 01-.25-.25v-5.5z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;